import React from "react";

import { IError } from "../../redux/actions/errorHandlingAction";

import { MainTabSection } from "./index.styles";
import { ErrorBox } from "../error-box/error-box.component";
import { withShowIf } from "../with-show-if/with-show-If.component";
import { ErrorPage404 } from "../error-page/error-page-404/error-page-404.component";

interface IBriefErrorMessage {
  errors: IError;
}

export const BriefErrorMessage = withShowIf(({ errors }: IBriefErrorMessage) => {
  const show404 = errors.status === 404;
  return (
    <MainTabSection>
      <ErrorPage404 showIf={show404} />
      <ErrorBox showIf={!show404} message={errors.errorMessage} title={errors.errorType} />
    </MainTabSection>
  );
});
